import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return dateStr;
  }
}

export function getReputationColor(rep) {
  if (rep >= 0.7) return 'text-emerald-400';
  if (rep >= 0.4) return 'text-amber-400';
  return 'text-red-400';
}

export function getReputationBg(rep) {
  if (rep >= 0.7) return 'bg-emerald-400/10 text-emerald-400 border-emerald-400/20';
  if (rep >= 0.4) return 'bg-amber-400/10 text-amber-400 border-amber-400/20';
  return 'bg-red-400/10 text-red-400 border-red-400/20';
}

export function getStateColor(value) {
  if (value >= 0.7) return '#E05252';
  if (value >= 0.4) return '#D8B07A';
  return '#22C7A3';
}

export function getStateLabel(key, value, lang = 'pl') {
  const labels = {
    pl: {
      zniecierpliwienie: value > 0.7 ? 'Wysoki' : value > 0.4 ? 'Średni' : 'Niski',
      zaciekawienie: value > 0.7 ? 'Wysokie' : value > 0.4 ? 'Średnie' : 'Niskie',
      dystans: value > 0.7 ? 'Wysoki' : value > 0.4 ? 'Średni' : 'Niski',
      satysfakcja: value > 0.7 ? 'Wysoka' : value > 0.4 ? 'Średnia' : 'Niska',
    },
    en: {
      zniecierpliwienie: value > 0.7 ? 'High' : value > 0.4 ? 'Medium' : 'Low',
      zaciekawienie: value > 0.7 ? 'High' : value > 0.4 ? 'Medium' : 'Low',
      dystans: value > 0.7 ? 'High' : value > 0.4 ? 'Medium' : 'Low',
      satysfakcja: value > 0.7 ? 'High' : value > 0.4 ? 'Medium' : 'Low',
    }
  };
  return labels[lang]?.[key] || 'Unknown';
}
